// import { useSelector } from "react-redux";


const BajajOrders = () => {
    //   const OrgId = useSelector((state) => state.auth.org_id)
      // console.log(OrgId, 'org_id__________')
      
      return (
        <div className="iframe-div">
            <iframe src= {`https://iipl.retool.com/embedded/public/7898ab8e-0923-4d62-833f-9f3222893265`}
            className="iframe-style"></iframe>
        </div>
      )
    };
    
    export default BajajOrders;
    